<template>
  <div class="card style=">
    <div v-if="title" class="card-header">
      {{ title }}
    </div>

    <div class="card-body">
      <slot/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Card',
  props: {
    title: { type: String, default: null }
  }
}
</script>



// WEBPACK FOOTER //
// resources/js/components/Card.vue